// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import CoupleNew from '../_raw/service/icon_couple_new.svg';
import withIconProps from '../withIconProps';

export default withIconProps(CoupleNew);
